import Quad from './quadratic';
import Cubic from './cubic';
import Arc from './arc';
import Line from './line';
import Polygon from './polygon';
import Polyline from './polyline';
import * as Util from './util';
export { Quad, Cubic, Arc, Line, Polygon, Polyline, Util };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g-math/esm/index.js
// module id = null
// module chunks = 